module.exports = __webpack_public_path__ + "img/Wp_2033.06703c93.png";